import { render } from "./WorkspacesModal2.vue?vue&type=template&id=4813bafa"
import script from "./WorkspacesModal2.vue?vue&type=script&lang=js"
export * from "./WorkspacesModal2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__